import React from 'react';
import { GraduationCapIcon, AwardIcon, UsersIcon } from 'lucide-react';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { boardService, civicLeadership, education } from '../data/profile';
export function BoardEducation() {
  return <PageShell path="/board-education" data-id="element-170" data-mp="2009jkgu5g5e6">
      <section id="board-service" className="bg-white py-20 lg:py-24" aria-labelledby="board-service-heading" data-id="element-171" data-mp="1zz7z5lr8u6js">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-172" data-mp="1uy0p1g1mov9y">
          <div id="board-service-heading" data-id="element-173" data-mp="1q0ilk56dr89c">
            <SectionHeading eyebrow="Board & Committee Service" title="Governance forums founded, chaired and served" data-id="element-174" data-mp="1l27gs8uxznxz" />
          </div>

          <ul className="mt-12 border-t border-platinum-200" data-id="element-175" data-mp="1h2ov3avar8u3">
            {boardService.map(service => <li key={service.body} className="grid grid-cols-1 gap-6 border-b border-platinum-200 py-8 lg:grid-cols-12 lg:gap-12" data-id="element-176" data-mp="3fdvygisk64m2">
                <div className="lg:col-span-4" data-id="element-177" data-mp="1s0j8atr5p6z9">
                  <p className="font-sans text-xs font-semibold uppercase tracking-[0.16em] text-gold-600" data-id="element-178" data-mp="1x1gox1wipsyn">
                    {service.period}
                  </p>
                  <h3 className="mt-3 font-display text-lg font-bold leading-snug tracking-tight text-navy-900" data-id="element-179" data-mp="1j3im8trk7kyz">
                    {service.body}
                  </h3>
                </div>
                <div className="lg:col-span-8" data-id="element-180" data-mp="2auez3udmdpm9">
                  <p className="font-display text-base font-semibold text-navy-900" data-id="element-181" data-mp="2fronr7t6px91">{service.role}</p>
                  <p className="mt-2 font-sans text-sm leading-relaxed text-charcoal-600 lg:text-base" data-id="element-182" data-mp="220tie5hw9ya7">
                    {service.detail}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>
      </section>

      <section id="education" className="bg-platinum-100 py-20 lg:py-24" aria-labelledby="education-heading" data-id="element-183" data-mp="2tpda6k2whcg7">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-184" data-mp="38dmzjy8iuke4">
          <div className="lg:col-span-5" data-id="element-185" data-mp="34bs2j5xmit65">
            <div id="education-heading" data-id="element-186" data-mp="34d32svrv1isi">
              <SectionHeading eyebrow="Education & Certification" title="Formal qualifications" data-id="element-187" data-mp="2zcymb5qyco2a" />
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-188" data-mp="2ud2ib6i98wmq">
            <div className="flex items-start gap-5 border-b border-platinum-300 pb-8" data-id="element-189" data-mp="2ughxe9bxi5o5">
              <GraduationCapIcon className="mt-1 h-6 w-6 shrink-0 text-gold-600" aria-hidden="true" data-id="element-190" data-mp="2pgc4kptxad4h" />
              <div data-id="element-191" data-mp="2km7s5r1w1cw0">
                <p className="font-display text-xl font-bold tracking-tight text-navy-900" data-id="element-192" data-mp="2gmqnv0y76lsf">
                  {education.degree}
                </p>
                <p className="mt-2 font-sans text-sm text-charcoal-600" data-id="element-193" data-mp="2boxg43h8xjq1">{education.degreeDetail}</p>
              </div>
            </div>

            <div className="flex items-start gap-5 pt-8" data-id="element-194" data-mp="26qduy5ah8byq">
              <AwardIcon className="mt-1 h-6 w-6 shrink-0 text-gold-600" aria-hidden="true" data-id="element-195" data-mp="21qrhpvunevpx" />
              <div className="w-full" data-id="element-196" data-mp="1rkhwdqial0fp">
                <p className="font-display text-base font-bold tracking-tight text-navy-900" data-id="element-197" data-mp="1rnm8rb5wv2hg">
                  Advanced certifications
                </p>
                <ul className="mt-4 divide-y divide-platinum-300 border-y border-platinum-300" data-id="element-198" data-mp="21kqwhffen60d">
                  {education.certifications.map(certification => <li key={certification.name} className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1 py-3.5" data-id="element-199" data-mp="18va76qn3058d">
                      <span className="font-sans text-base font-medium text-navy-900" data-id="element-200" data-mp="1ithl10m2q765">
                        {certification.name}
                      </span>
                      <span className="font-sans text-xs uppercase tracking-[0.14em] text-charcoal-600" data-id="element-201" data-mp="1nl928kjcb0jm">
                        {certification.detail}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="civic" className="bg-navy-900 py-20 lg:py-24" aria-labelledby="civic-heading" data-id="element-202" data-mp="2rtpxjmwdnad4">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-203" data-mp="36im2vc71u9a1">
          <div id="civic-heading" data-id="element-204" data-mp="36k6wmzljho6u">
            <SectionHeading eyebrow="Civic Leadership" title="Contribution beyond the organisation" tone="dark" data-id="element-205" data-mp="31rvzu5m3iiii" />
          </div>

          <ul className="mt-12 grid grid-cols-1 gap-px bg-white/10 lg:grid-cols-3" data-id="element-206" data-mp="3fldebbzxd51o">
            {civicLeadership.map(item => <li key={item.title} className="flex flex-col bg-navy-900 p-8" data-id="element-207" data-mp="3pi02a9njsc7x">
                <UsersIcon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-208" data-mp="3kidnhvs2mnx0" />
                <h3 className="mt-5 font-display text-base font-bold leading-snug text-white" data-id="element-209" data-mp="3kgamyhtalce1">
                  {item.title}
                </h3>
                <p className="mt-auto pt-4 font-sans text-sm leading-relaxed text-platinum-300" data-id="element-210" data-mp="1q55p5u4vzu6m">
                  {item.detail}
                </p>
              </li>)}
          </ul>
        </div>
      </section>
    </PageShell>;
}